import React, { useRef, useState } from 'react';
import {
  BaseButton,
  Input,
  useAuth,
  PasswordIndicator,
  useIsMobile,
  useT,
} from '@repo/common';
import { updatePassword } from '../../../../api/user/user.api';

const getInputState = (focused, validationState) => {
  if (['failed', 'success', 'warning'].includes(validationState))
    return validationState;
  if (focused) return 'active';
  return 'default';
};

const NewPasswordForm = ({
  onClose,
  onSuccess,
  isDeleteAccount = false,
  onPasswordChange,
  externalLoading,
}) => {
  const t = useT();
  const { user, refreshUser } = useAuth();
  const isMobile = useIsMobile();
  const passwordInputRef = useRef(null);
  const [password, setPassword] = useState('');
  const [passwordFocused, setPasswordFocused] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const hasPw = user?.hasPw;

  const effectivePasswordStatus = getInputState(passwordFocused, 'default');

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    onPasswordChange?.(e.target.value);
  };
  const handleStrengthChange = (level) => setPasswordStrength(level);
  const handleChangeClick = async () => {
    setIsLoading(true);
    try {
      await updatePassword(password);
      await refreshUser();
      onClose?.();
      onSuccess?.();
    } catch (error) {
      console.error('비밀번호 변경 실패:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className={`flex flex-col items-start tabletH:items-end ${!isDeleteAccount && isMobile ? 'pt-4 pb-10' : ''} tabletH:p-0 tabletH:gap-4 w-full `}
    >
      <Input
        id='password-input'
        ref={passwordInputRef}
        label=''
        placeholder={t('Enter a new password', '새 비밀번호를 입력해 주세요')}
        isPassword
        value={password}
        state={effectivePasswordStatus}
        onChange={handlePasswordChange}
        showStatusIcon={false}
        onFocus={() => setPasswordFocused(true)}
        onBlur={() => setPasswordFocused(false)}
        className='w-full'
      />

      {!isDeleteAccount && password && (
        <div className='mt-4 tabletH:mt-0 w-full'>
          <PasswordIndicator
            password={password}
            onStrengthChange={handleStrengthChange}
            isAccountSetting
          />
        </div>
      )}

      {!isDeleteAccount && (
        <div className='mt-[30px] tabletH:mt-0'>
          <BaseButton
            hideIcon
            onClick={handleChangeClick}
            isLoading={isLoading}
            isDisabled={passwordStrength < 4 || !password}
          >
            {hasPw ? t('Change', '변경') : t('Create', '생성')}
          </BaseButton>
        </div>
      )}
    </div>
  );
};

export default NewPasswordForm;
